module.exports = __webpack_public_path__ + "media/images/icons/filled/exclamation-circle-d06e1ac6cd54d0d2d0ae679a8e53f2a6.svg";